import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { HallOfFames } from 'app/hall-of-fame/hall-of-fame';

@Injectable({ providedIn: 'root' })
export class HallOfFamesService {
    baseUrl: string = '';

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this.baseUrl = baseUrl + 'api/HallOfFames';
    }

    getHallOfFames(): Observable<HallOfFames[]> {
        return this.http.get<HallOfFames[]>(this.baseUrl);
    }

    getHallOfFameById(id: number): Observable<HallOfFames> {
        return this.http.get<HallOfFames>(`${this.baseUrl}/${id}`);
    }

    createHallOfFame(params: HallOfFames): Observable<HallOfFames> {
        return this.http.post<any>(this.baseUrl, params);
    }

    updateHallOfFame(id: number, calEvent: HallOfFames): Observable<any> {
        return this.http.put(`${this.baseUrl}/${id}`, calEvent);
    }

    deleteHallOfFame(id: number): Observable<HallOfFames> {
        return this.http.delete<HallOfFames>(`${this.baseUrl}/${id}`);
    }

    getMostRecent(): Observable<HallOfFames[]> {
        return this.http.get<HallOfFames[]>(`${this.baseUrl}/mostrecent`);
    }
}
